import { createAction, props } from '@ngrx/store';

import { IResultResetUser } from '../../shared/models/Tenderos.interface';

/*
 * Manda a validar los datos para reseteo
 */
export const validResetUser = createAction(
    '[ResetUser] Reset User',
    props<{ ID_Bodega: number; NUD: number; Monto: number; RutaPPP: string; }>()
);

export const successValidResetUser = createAction(
    '[ResetUser] Success Reset User',
    props<IResultResetUser>()
);

export const errorValidResetUser = createAction(
    '[ResetUser] Error Reset User',
    props<{ payload: Error }>()
);

export const clearValidResetUser = createAction('[ResetUser] Clear Reset User');